import Translate from '../Translate/Translate';
import NextAttemptCountdown from './NextAttemptCountdown';
import React from 'react';
import RenderIf from '../RenderIf/RenderIf';
import {ErrorNextRetryDetailsProps} from '../../@types/components/ErrorRepresentation';

export default function ErrorNextRetryDetails(props: ErrorNextRetryDetailsProps) {
    const {
        maxAttemptsNumber,
        retryButtonDisabled,
        retryInProcess = false,
        retryAttempts,
        lastAttemptAtDate,
        nextTryInSecondsText,
        nextTrySoonText,
        nextTryNowText,
        triedAttemptsText,
    } = props;

    const shouldDisplay = (
            retryButtonDisabled && lastAttemptAtDate && nextTryInSecondsText ||
            retryAttempts !== undefined && triedAttemptsText
    );

    if (!shouldDisplay) {
        return null;
    }

    return <div className="row no-gutters text-muted w-100 ps-2">
        <RenderIf
                expression={retryButtonDisabled && lastAttemptAtDate && nextTryInSecondsText}
                render={() => {
                    return <div className="col-md-6">
                        <RenderIf
                                expression={retryInProcess}
                                render={() => nextTryNowText ? <Translate message={nextTryNowText}/> : null}
                                renderElse={() => {
                                    return <NextAttemptCountdown
                                            countUntil={lastAttemptAtDate as any}
                                            message={nextTryInSecondsText as string}
                                            soonMessage={nextTrySoonText}
                                    />;
                                }}
                        />
                    </div>;
                }}
        />

        <RenderIf
                expression={retryAttempts !== undefined && triedAttemptsText}
                render={() => {
                    return <Translate
                            tag="div"
                            className="ms-auto col-md-6 text-md-end"
                            message={triedAttemptsText as string}
                            replace={{
                                current: Math.min(maxAttemptsNumber, retryAttempts as number),
                                max: maxAttemptsNumber,
                            }}
                    />;
                }}
        />
    </div>;
}
